import { useState } from "react";
import { FilterActions } from "./FilterActions.tsx";

export type AmountRangeFilterValue = {
  minInCents?: number;
  maxInCents?: number;
};

function centsToInput(cents?: number): string {
  return cents === undefined ? "" : String(cents / 100);
}

function inputToCents(input: string): number | undefined {
  const euros = Number(input.replace(",", "."));
  return input.trim() && Number.isFinite(euros) && euros >= 0
    ? Math.round(euros * 100)
    : undefined;
}

const amountInputClassName =
  "w-full rounded-md border border-gray-300 px-2 py-1.5 text-sm text-gray-700";

export function AmountRangeFilter({
  value,
  onApply,
  close,
}: {
  value: AmountRangeFilterValue;
  onApply: (value: AmountRangeFilterValue) => void;
  close: () => void;
}) {
  const [min, setMin] = useState(centsToInput(value.minInCents));
  const [max, setMax] = useState(centsToInput(value.maxInCents));
  const apply = (next: AmountRangeFilterValue) => {
    onApply(next);
    close();
  };

  return (
    <div className="flex flex-col gap-2 px-2">
      <div className="grid grid-cols-2 gap-2">
        <label className="flex flex-col gap-1 text-xs text-gray-500">
          Da (€)
          <input
            inputMode="decimal"
            value={min}
            onChange={(e) => setMin(e.target.value)}
            placeholder="0"
            className={amountInputClassName}
          />
        </label>
        <label className="flex flex-col gap-1 text-xs text-gray-500">
          A (€)
          <input
            inputMode="decimal"
            value={max}
            onChange={(e) => setMax(e.target.value)}
            placeholder="∞"
            className={amountInputClassName}
          />
        </label>
      </div>
      <FilterActions
        canClear={
          value.minInCents !== undefined || value.maxInCents !== undefined
        }
        onClear={() => apply({})}
        onApply={() =>
          apply({
            minInCents: inputToCents(min),
            maxInCents: inputToCents(max),
          })
        }
      />
    </div>
  );
}
